import { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Box, Button, Typography } from "@mui/material";

function FileUpload({ onFileAccepted, trigger }) {
  const [error, setError] = useState("");
  const [borderColor, setBorderColor] = useState("#ccc");
  const MAX_SIZE = 10 * 1024 * 1024; // 10 MB

  // Function to validate PDF file
  const validatePDF = (file) => {
    return new Promise((resolve, reject) => {
      if (file.type !== "application/pdf") {
        reject("Il file non è un PDF.");
        return;
      }
      if (file.size > MAX_SIZE) {
        reject("Il file supera la dimensione massima di 10 MB.");
        return;
      }
      // Check PDF magic number (first 4 bytes should be %PDF)
      const reader = new FileReader();
      reader.onloadend = (e) => {
        const arr = new Uint8Array(e.target.result).subarray(0, 4);
        const header = String.fromCharCode(...arr);
        if (header === "%PDF") {
          resolve(true);
        } else {
          reject("Il file non è un PDF valido.");
        }
      };
      reader.onerror = () => reject("Errore nella lettura del file.");
      reader.readAsArrayBuffer(file.slice(0, 4));
    });
  };

  const onDropAccepted = useCallback(
    async (acceptedFiles) => {
      const file = acceptedFiles[0];

      if (!file) {
        setError("Nessun file selezionato.");
        setBorderColor("red");
        return;
      }

      try {
        await validatePDF(file);
        setError("");
        setBorderColor("#ccc");
        onFileAccepted(acceptedFiles); // Pass the valid file to the parent
      } catch (errMsg) {
        setError(errMsg);
        setBorderColor("red");
      }
    },
    [onFileAccepted]
  );

  const { getRootProps, getInputProps, open } = useDropzone({
    onDropAccepted,
    onDropRejected: () => {
      setError("Il file deve essere in formato PDF e max 10 MB.");
      setBorderColor("red");
    },
    accept: { "application/pdf": [".pdf"] },
    maxSize: MAX_SIZE,
    noClick: true,
    noKeyboard: true,
  });

  return (
    <Box>
      <input {...getInputProps()} />
      {trigger ? (
        trigger({ open })
      ) : (
        <Box
          {...getRootProps()}
          sx={{
            border: `2px dashed ${borderColor}`,
            padding: "20px",
            textAlign: "center",
            cursor: "pointer",
            borderRadius: "4px",
          }}
        >
          <Typography variant="h6">Trascina qui un file PDF</Typography>
          <Typography variant="body2" my={4}>
            Oppure
          </Typography>
          <Button variant="outlined" onClick={open}>
            Seleziona un file
          </Button>
        </Box>
      )}
      {error && (
        <Typography variant="body2" color="error" sx={{ marginTop: "10px" }}>
          {error}
        </Typography>
      )}
    </Box>
  );
}

export default FileUpload;
